document.addEventListener('DOMContentLoaded', () => {
  function updateColumnCount() {
    const productGrid = document.querySelector('.grid-cols-adjustable');
    const facetsWrapper = document.querySelector('.facets-wrapper');

    if (productGrid && facetsWrapper) {
      const baseColumns = parseInt(productGrid.dataset.baseColumns);
      const isVisible = facetsWrapper.classList.contains('is-visible');
      const currentCols = isVisible ? baseColumns - 1 : baseColumns;

      productGrid.classList.remove(`grid--${baseColumns}-col-desktop`);
      productGrid.classList.remove(`grid--${baseColumns - 1}-col-desktop`);
      productGrid.classList.add(`grid--${currentCols}-col-desktop`);
    }
  }

  // Initial setup
  const filterToggleBtn = document.querySelector('.filter-toggle-btn');
  const facetsWrapper = document.querySelector('.facets-wrapper');
  const productGrid = document.querySelector('.grid-cols-adjustable');

  if (filterToggleBtn && facetsWrapper && productGrid) {
    // Check stored state and apply it on page load
    const filtersVisible = localStorage.getItem('filtersVisible') === 'true';
    if (filtersVisible) {
      document.body.classList.add('filters-visible');
      facetsWrapper.classList.add('is-visible');
    }

    updateColumnCount();

    filterToggleBtn.addEventListener('click', () => {
      document.body.classList.toggle('filters-visible');
      facetsWrapper.classList.toggle('is-visible');

      const isVisible = facetsWrapper.classList.contains('is-visible');
      localStorage.setItem('filtersVisible', isVisible);

      updateColumnCount();
    });
  }

  // Watch for product grid container updates
  const productGridContainer = document.getElementById('ProductGridContainer');
  if (productGridContainer) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          // Find the new product grid and update its classes
          const newProductGrid = productGridContainer.querySelector(
            '.grid-cols-adjustable'
          );
          if (newProductGrid) {
            updateColumnCount();
          }
        }
      });
    });

    observer.observe(productGridContainer, {
      childList: true,
      subtree: true,
    });
  }
});
